import { take, fork, call } from 'redux-saga/effects';
import fetchUserInfo from './fetchUserInfo';
import fetchSessionStatus from './fetchSessionStatus';
import { CARD_ADD_SUCCEEDED } from '../actions/payment';

export default function* () {
  while (true) {
    yield take(CARD_ADD_SUCCEEDED);
    const { sessionStatus, session } = yield call(fetchSessionStatus);

    if (session) {
      yield fork(fetchUserInfo, sessionStatus.accountReference, session);
    }
  }
}
